import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ProductList from "@/pages/ProductList";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import MyOrders from "@/pages/MyOrders";
import BecomeSeller from "@/pages/BecomeSeller";
import VendorDashboard from "@/pages/VendorDashboard";
import VendorProducts from "@/pages/VendorProducts";
import VendorOrders from "@/pages/VendorOrders";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminVendors from "@/pages/AdminVendors";
import AdminProducts from "@/pages/AdminProducts";
import AdminSettlements from "@/pages/AdminSettlements";
import RoleRoute from "@/components/RoleRoute";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ReturnPolicy from "@/pages/ReturnPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import ShippingPolicy from "@/pages/ShippingPolicy";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import AdminMessages from "@/pages/AdminMessages";
import Track from "@/pages/Track";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background: "#0F3D2E", color: "white", border: "1px solid #14A085" },
            }}
          />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<RoleRoute roles={["buyer","vendor","admin"]}><MyOrders /></RoleRoute>} />
              <Route path="/sell" element={<BecomeSeller />} />
              <Route path="/vendor" element={<RoleRoute roles={["vendor"]}><VendorDashboard /></RoleRoute>} />
              <Route path="/vendor/products" element={<RoleRoute roles={["vendor"]}><VendorProducts /></RoleRoute>} />
              <Route path="/vendor/orders" element={<RoleRoute roles={["vendor"]}><VendorOrders /></RoleRoute>} />
              <Route path="/admin" element={<RoleRoute roles={["admin"]}><AdminDashboard /></RoleRoute>} />
              <Route path="/admin/vendors" element={<RoleRoute roles={["admin"]}><AdminVendors /></RoleRoute>} />
              <Route path="/admin/products" element={<RoleRoute roles={["admin"]}><AdminProducts /></RoleRoute>} />
              <Route path="/admin/settlements" element={<RoleRoute roles={["admin"]}><AdminSettlements /></RoleRoute>} />
              <Route path="/admin/messages" element={<RoleRoute roles={["admin"]}><AdminMessages /></RoleRoute>} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
              <Route path="/faqs" element={<FAQs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/track/:awb" element={<Track />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
